import React from 'react';
import ReactDOM from 'react-dom/client';
// Remove Redux imports and use a local context provider instead
import store from './store';
import './index.css';
import './styles/global.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Create a mock Provider component that passes the store via context
// This allows us to maintain compatibility without actual Redux
const MockProvider = ({ store, children }: { store: any, children: React.ReactNode }) => {
  return React.createElement(
    React.createContext(store).Provider,
    { value: store },
    children
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <MockProvider store={store}>
      <App />
    </MockProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
